module.exports = __webpack_public_path__ + "img/wellve_2.2958a3d8.jpg";